import React from 'react'

const Dashboard = props => (
    <svg {...props}>
        <path d="M57.863 26.632l-8.681-8.061V5.365h-10v3.921L29.182 0 .502 26.632a1.001 1.001 0 001.362 1.466l3.319-3.082v33.349h48v-33.35l3.319 3.082a.995.995 0 00.681.267 1 1 0 00.68-1.732zM41.182 7.365h6v9.349l-6-5.571V7.365zm-18 49V35.302c0-.517.42-.937.937-.937h10.126c.517 0 .937.42.937.937v21.063h-12zm28 0h-14V35.302a2.94 2.94 0 00-2.937-2.937H24.119a2.94 2.94 0 00-2.937 2.937v21.063h-14V23.158l22-20.429 14.28 13.26 5.72 5.311 2 1.857v33.208z"></path>
    </svg>
)

export default Dashboard
